import { AgeRanges } from '../user/age-ranges';
import { RequestedGenders } from '../user/requested-genders';
import { Address } from '../address/address';
import { RoomSearchStatuses } from './room-search-statuses';
import { AllowedTenantTypes } from '../property/allowed-tenant-types';

export class RoomSearch {
    maximumBudget: number;
    minAgeRange: AgeRanges;
    maxAgeRange: AgeRanges;
    moveFrom: Date;
    requestedGender: RequestedGenders;
    status: RoomSearchStatuses;    
    areas: Address[];
    allowedTenantType: AllowedTenantTypes;
    guid: string;
}
